import { Button, ButtonColor, ImageUploader, ImageUploaderType, Input } from "@swivl-mono/ui";
import { type ChangeEvent, useEffect, useState } from "react";

import { Member } from "../../../../Models/Member/Member.Current";
import MembersModel from "../../../../Models/Member/Members.Model";
import { NavBar } from "../../../../Models/NavBar/NavBar.Model";
import { useSwivlNavigate } from "../../../../Models/NavBar/useSwivlNavigate";
import "./AgentSettingsView.scss";

interface State {
  name?: string;
  agentAvatarURL?: string;
  errorMsg?: string;
  isSaving: boolean;
  isDirty: boolean;
}

export default function AgentSettingsView() {
  const [state, setState] = useState<State>({
    isSaving: false,
    isDirty: false,
    name: Member?.member?.agentName,
    agentAvatarURL: Member?.member?.agentAvatarURL || "",
  });

  const navigate = useSwivlNavigate();
  const { name, agentAvatarURL, errorMsg, isSaving, isDirty } = state;

  useEffect(() => {
    NavBar.set(<NavBar.Component.Back />, <NavBar.Component.Title title="Agent Settings" />, null, "Agent Settings");
  }, []);

  useEffect(() => {
    setState({
      name: Member?.member?.agentName,
      agentAvatarURL: Member?.member?.agentAvatarURL || "",
      errorMsg: "",
      isSaving: false,
      isDirty: false,
    });
  }, [Member]);

  useEffect(() => {
    if (name !== Member?.member?.agentName || agentAvatarURL !== Member?.member?.agentAvatarURL) {
      setState({
        ...state,
        isDirty: true,
      });
    }
  }, [name, agentAvatarURL]);

  const onChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.name === "name" && e.target.value !== Member?.member?.agentName
      || e.target.name === "agentAvatarURL" && e.target.value !== Member?.member?.agentAvatarURL) {
      setState({ ...state, ...{ isDirty: true } });
    }
    setState({ ...state, ...{ [e.target.name]: e.target.value, errorMsg: undefined } });
  };

  const doneClicked = () => {
    navigate(-1);
  };

  const saveClicked = () => {
    if (!name || name.length === 0) {
      setState({ ...state, ...{ errorMsg: "You must enter a display name" } });
      return;
    }
    setState({ ...state, ...{ isSaving: true } });

    if (name && agentAvatarURL && Member && Member.id) {
      MembersModel.updateMember({ id: Member.id, agentName: name, agentAvatarURL }).then(() => {
        setState({ ...state, isSaving: false, isDirty: false, errorMsg: undefined });
      });
    } else {
      setState({ ...state, isSaving: false, errorMsg: "Member ID not found" });
    }
  }

  const errorView = errorMsg ? <div className="errorMsg">{errorMsg}</div> : null;

  let createHeader;

  return (
    <div className="AgentSettingsView">
      <div className="content">
        {createHeader}

        <div className="agentSettingsForm">
          <div className="mb-6">
            <ImageUploader
              isEditable={true}
              imageURL={agentAvatarURL}
              type={ImageUploaderType.AVATAR}
              imageUploaded={(url) => {
                setState({ ...state, ...{ agentAvatarURL: url } });
              }}
              text="Upload Image"
            />
          </div>
          <label>Display Name</label>
          <small>This will appear for users you chat with.</small>
          <Input placeholder="Enter display name..." value={name} name="name" onChange={onChange} />
          {errorView}
          <div className="flex gap-2">
            <Button disabled={!isDirty} loading={isSaving} color={ButtonColor.ORANGE} onClick={saveClicked}>
              Save
            </Button>
            <Button onClick={doneClicked}>Done</Button>
          </div>
        </div>
      </div>
    </div>
  );
}

